import { ExtensionType } from "@/client/services/api/graphql/gql/graphql";

export function getExtensionTypeFromFile(file: File): ExtensionType {
  const mimeType = file.type.toLowerCase();
  const fileName = file.name.toLowerCase();
  const fileExtension = fileName.split('.').pop() || '';

  // Map MIME types to ExtensionType
  const mimeTypeMap: Record<string, ExtensionType> = {
    'application/pdf': ExtensionType.Pdf,
    'text/csv': ExtensionType.Csv,
    'application/vnd.ms-excel': ExtensionType.Xls,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ExtensionType.Xlsx,
    'application/msword': ExtensionType.Doc,
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ExtensionType.Docx,
    'text/plain': ExtensionType.Txt,
    'text/markdown': ExtensionType.Md,
  };

  // Try MIME type first
  if (mimeType && mimeTypeMap[mimeType]) {
    return mimeTypeMap[mimeType];
  }

  // Fall back to file extension
  const extensionMap: Record<string, ExtensionType> = {
    pdf: ExtensionType.Pdf,
    csv: ExtensionType.Csv,
    xls: ExtensionType.Xls,
    xlsx: ExtensionType.Xlsx,
    doc: ExtensionType.Doc,
    docx: ExtensionType.Docx,
    txt: ExtensionType.Txt,
    md: ExtensionType.Md,
  };

  if (extensionMap[fileExtension]) {
    return extensionMap[fileExtension];
  }

  // Default to TXT if no match found
  return ExtensionType.Txt;
}